import { snakeCaseToPascalCase } from 'utils/Strings';

export const seriesLabelKey = (serie: DeviceSeries) => {
  return 'deviceTier' + snakeCaseToPascalCase(serie) + 'LabelKey';
};

export const seriesDescKey = (serie: DeviceSeries) => {
  return 'deviceTier' + snakeCaseToPascalCase(serie) + 'DescKey';
};

export const SERIES_ORDER: DeviceSeries[] = ['direct_plus', 'direct', 'partner'];
